// Copyright: IQGeo Limited 2010-2019
import $ from 'jquery';
import myw from 'myWorld-base';
import Webcam from 'webcam';

myw.WebcamDialog = myw.Control.extend({
    events: {
        'click #take_photo': 'takeSnapshot',
        'click #retake_photo': 'retakeSnapshot',
        'click #select_photo': 'selectSnapshot'
    },

    /**
     * @class Dialog to view the webcam data and capture a snapshot
     * @param  {callback}   callback         Callback to the method that takes the data_uri of the snapshot once it is selected by the user
     * @constructs
     */
    initialize(owner, options) {
        myw.Control.prototype.initialize.call(this, owner, options);

        this.callback = options.callback;

        this.render();
    },

    render() {
        this.$el.append('<div id="webcam_viewer"></div>').dialog({
            modal: true,
            autoOpen: false,
            width: 'auto',
            resizable: false,
            position: { my: 'center', at: 'top+160', of: window },
            title: 'Webcam',
            close() {
                Webcam.reset(); // shut down camera, stop capturing
            }
        });
        this.takePhotoBtn = $(
            `<div id="take_photo" title="${this.msg('take_photo')}"></div>`
        ).appendTo(this.$el);

        this.previewActions = $('<div id="preview_actions"></div>')
            .hide()
            .appendTo(this.$el)
            .append(`<span id="retake_photo" title="${this.msg('retake_photo')}"></span>`)
            .append(`<span id="select_photo" title="${this.msg('select_photo')}"></span>`);
    },
    open() {
        //Calculate the size of the webcam viewer (either 640x480 or 480x360) restricting it within the window bounds
        const windowHeight = $(window).height() - 150,
            windowWidth = $(window).width() - 50,
            maxWidth = 640 < windowWidth && 480 < windowHeight ? 640 : 480,
            maxHeight = (maxWidth * 3) / 4;

        Webcam.set({
            width: maxWidth,
            height: maxHeight,
            image_format: 'jpeg',
            jpeg_quality: 90
        });
        Webcam.attach(this.$el.find('#webcam_viewer')[0]);
        this.retakeSnapshot();
        this.$el.dialog('open');
    },
    takeSnapshot() {
        Webcam.freeze();
        this.takePhotoBtn.hide();
        this.previewActions.show();
    },
    retakeSnapshot() {
        Webcam.unfreeze();
        this.takePhotoBtn.show();
        this.previewActions.hide();
    },
    /**
     * Takes a snapshot and sends the resulting data_url to the callback method
     */
    selectSnapshot() {
        Webcam.snap(data_uri => {
            this.$el.dialog('close');
            this.callback(data_uri);
        });
    }
});

export default myw.WebcamDialog;
